module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAA4ElEQVQoU2NctWoV85sPX+r+sDBMyUtKes2AA0yaN0+U9TdjtrAgd3NYWNhfxhmzFjT/+/+vhoGB8eof1v+O2DSDNLH8ZtjHwMCgw8TI1JKRllDLCBFk3M/A8F8bm2Zc8owgl+GSxGcoWCM2zUz//4f9Y2RchcslcI2Ymhn+MzAwMOLyO4pGkOYZM+Zp/WNkuALRxPCf6T+DTkZG0jX0wKbcRvSAIMqP6JoY/zE7ZWbGvcIbqrg04QptWCJBSTkwm9ADAtlweMoBpdW377/WM/xjngJyHoG0missyN0ISqsAsLfMDuv7/KsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg/close.png
// module id = x7Df
// module chunks = 35